export enum TagCategories {
  body = 1,
  experiences = 2,
  feelings = 3,
  novelty_and_play = 4,
  relationships = 5,
  thoughts = 6,
}
